import request from "@/utils/request.js";

// 设置-商品-商品列表
export const itemListIgnore = (pageData, formData) => {
    return request.post(`/goods/ignoreTenant/page/${pageData.page}/${pageData.pageSize}`, formData)
}
